export default __webpack_public_path__ + "static/media/keto_active@3x.83cdd5ff.jpg";